export enum PaymentType {
    Cash = 0, 
    PaymentCard = 15
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/payment-type.enum.ts